import { smoothScrollTo } from '../../utilities/js/helper';
import './back-to-top.scss';

class BackToTop {
    constructor ($element) {
        this.$backToTop = $element;
        this.$backToTopLink = this.$backToTop.querySelector('a');
        this.showButtonTimer = null;
    }

    initialize () {
        this.setEvents();
        this.checkButton();
    }

    checkButton () {
        const scrollInfo = window.eventScroller.getScrollInfo();

        if (scrollInfo.position >= window.innerHeight) {
            this.$backToTop.classList.add('back-to-top--visible');
        } else {
            this.$backToTop.classList.remove('back-to-top--visible');
        }

        this.scrollPosition = scrollInfo.position;
    }

    setEvents () {
        this.$backToTopLink.addEventListener('click', (e) => {
            const speed = this.scrollPosition / window.innerHeight * 250;
            smoothScrollTo(0, 0, speed);
        });

        window.eventScroller.customFunctions.push(() => {
            clearTimeout(this.showButtonTimer);
            this.showButtonTimer = window.setTimeout(() => {
                this.checkButton();
            }, 250);
        });
    }
}

export { BackToTop };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $backToTop = $context.querySelector('[data-backtotop="root"]');
        if ($backToTop) {
            const backToTop = new BackToTop($backToTop);
            backToTop.initialize();
        }
    }
});
